import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './antdCommon.scss';
import App from './App';
import { HashRouter } from 'react-router-dom'
import "@fontsource/source-sans-pro/400.css";
import "@fontsource/source-sans-pro/600.css";
import "@fontsource/source-sans-pro/700.css";
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <HashRouter>
        <App />
    </HashRouter>
);

